import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  files: { data: [], loading: false },
  policy: { data: null, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  selected: null,
  loading: false,
  paths: [],
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
